import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createBlock(_component_svg_icon, {
    width: _ctx.width,
    height: _ctx.height,
    iconColor: _ctx.iconColor,
    viewBoxWidth: "32",
    viewBoxHeight: "32",
    strokeWidth: "3"
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("line", {
        x1: "22",
        y1: "10",
        x2: "10",
        y2: "22"
      }, null, -1),
      _createElementVNode("line", {
        x1: "10",
        y1: "10",
        x2: "22",
        y2: "22"
      }, null, -1)
    ])),
    _: 1,
    __: [0]
  }, 8, ["width", "height", "iconColor"]))
}